// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uNYBvavDBWmsZA {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 96px;
  padding: var(--ds-space-100, 8px);
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-regular, 400);
  text-align: center;
}
.uNYBvavDBWmsZA:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.FdcUZ8Pg9B6NNQ {
  height: 100%;
  min-height: 108px;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.O37ZVBJ2gAzyc3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var boardTile = `uNYBvavDBWmsZA`;
export var newBoardTile = `FdcUZ8Pg9B6NNQ`;
export var boardDetails = `O37ZVBJ2gAzyc3`;
export default ___CSS_LOADER_EXPORT___;
